import { Component, OnInit, ViewChild } from '@angular/core';
import { Filtro } from '../models/filtro';
import { Feriado } from '../models/feriado';
import { MatPaginator, PageEvent } from '@angular/material';
import { UtilitarioService } from '../services/utilitario.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginatorService } from '../services/paginator.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { FeriadoService } from '../services/feriado.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-feriado',
  templateUrl: './feriado.component.html',
  styleUrls: ['./feriado.component.scss']
})
export class FeriadoComponent implements OnInit {
  feriados: Feriado[] = [];
  carregando = true;
  campoOrdenacao = 'data';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private feriadoService: FeriadoService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private paginatorService: PaginatorService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarFeriados();
  }

  novoFeriado() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarFeriado(feriado: Feriado) {
    this.router.navigate(['editar', feriado.id], { relativeTo: this.route });
  }

  buscarFeriados() {
    this.carregandoService.mostra('buscaEmbalagens');
    this.carregando = true;

    this.feriadoService.consultarComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe((data) => {
        this.feriados = data.itens;
        this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(data.total);

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = data.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaEmbalagens');

      }, (erro) => {
        this.carregandoService.esconde('buscaEmbalagens');
        this.notificacaoService.erro(erro);
      });
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFeriados();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.feriados = this.feriados.sort((a, b) => {
        const isAsc = !this.ordenarDesc;

        switch (this.campoOrdenacao) {
          case 'descricao': return this.compare(a.descricao, b.descricao, isAsc);
          default: return 0;
        }
      });

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  filtra() {
    this.buscarFeriados();
    this.paginator.firstPage();
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  excluir(feriado: Feriado) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Feriado?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      this.carregandoService.mostra('softDeleteEmb');

      this.feriadoService.excluir(feriado.id).subscribe(data => {
        this.notificacaoService.sucesso("Feriado excluído com sucesso!");
        this.carregandoService.esconde('softDeleteEmb');
        this.filtra();
      }, (erro) => {
        this.carregandoService.esconde('softDeleteEmb');
        this.notificacaoService.erro("Não foi possível excluir o feriado.");
      });
    });
  }

}
